module.exports = __webpack_public_path__ + "media/assets/images/logos/offcar_logo-73bf3f89318dd9619dcdd7416e7907da.png";